import { render, staticRenderFns } from "./TipoOcorrencia.vue?vue&type=template&id=459d1878"
import script from "./TipoOcorrencia.vue?vue&type=script&lang=js"
export * from "./TipoOcorrencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports